import { useDispatch } from "react-redux";
import { useState } from "react";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { enableModal } from "../../store/mainReducer";
import { checkTicketQR } from "../../api/tickets";
import { QrReader } from "react-qr-reader";

export const CheckQR = () => {
  const dispatch = useDispatch();
  const checkQRMsg = [
    "Still checking...",
    "Valid QR",
    "Invalid QR",
    "QR expired",
    "QR already checked",
    "QR checking in progress",
    "Please center the QR for reading",
  ];
  const [facingMode, setFacingMode] = useState("environment");
  const msgColor = [
    COLORS.gradientBackground,
    COLORS.lightNeon,
    COLORS.red,
    COLORS.blue,
    COLORS.yellow,
    COLORS.yellow,
    COLORS.white,
  ];
  const [QRMessage, setQRMessage] = useState(checkQRMsg[6]);
  const [responseCode, setResponseCode] = useState(6);

  let eventToCheckQR = JSON.parse(
    window.localStorage.getItem("eventToCheckQR")
  );
  if (!eventToCheckQR) {
    console.log(
      "Error! no eventToCheckQR to check for, use default test event 630e3289cd4eac2f6cd58b84"
    );
    eventToCheckQR = "630e3289cd4eac2f6cd58b84";
  }

  /**
   * Check one QR at a time
   */
  let prevCheckedQR;

  // const [QR, setQR] = useState(null);
  // const ticketIDQR = JSON.parse(window.localStorage.getItem("ticketIDQR"));
  // // let nowDate=
  // const QrInMins = 5;
  const handleClose = () => {
    dispatch(enableModal(false));
  };

  /**
   * Show and check the QR info. See above the 5 possible results of the checking
   */
  const showQRInfo = async (result) => {
    prevCheckedQR = result?.text;
    // the code stacked in QR
    let presentedQR = result?.text;

    try {
      let QRCheckRes = await checkTicketQR(presentedQR, eventToCheckQR);
      if (QRCheckRes.data) {
        QRCheckRes = QRCheckRes.data;
      } else {
        setQRMessage("Error checking the QR on the server");
        setResponseCode(5);
      }

      if (QRCheckRes.code) {
        setQRMessage(checkQRMsg[QRCheckRes.code]);
        setResponseCode(QRCheckRes.code);
      }

      if (QRCheckRes.owner) {
        let msg = `Valid! Owner: ${QRCheckRes.owner}`;
        setQRMessage(msg);
        setResponseCode(1);
      }
      setQRResetTimeout();
    } catch (err) {
      setQRMessage(`Error: ${err}`);
      setResponseCode(5);
    }

    /**
     * Refresh the checking component after a ticket was checked
     */
    function setQRResetTimeout() {
      setTimeout(() => {
        setQRMessage(checkQRMsg[6]);
        setResponseCode(6);
        prevCheckedQR = null;
      }, 3000);
    }
  };

  let handleCameraChange = (e) => {
    let myIcon = e.target;
    if (facingMode === "environment") {
      myIcon.style.rotate = "180deg";
      setFacingMode("user");
    } else {
      myIcon.style.rotate = "0deg";
      setFacingMode("environment");
    }
  };

  return (
    <div
      className="container-column"
      style={{
        backgroundColor: msgColor[responseCode],
      }}
    >
      {/* <img src={qrCode} alt="ticket" /> */}
      {/* button to change the way the camera is showing */}
      <div className="qr-reader-container">
        <QrReader
          constraints={{ facingMode: "environment" }}
          videoId="video"
          scanDelay="1000"
          onResult={(result, error) => {
            if (!!result) {
              if (prevCheckedQR != result?.text) {
                showQRInfo(result);
              }
            }
            if (!!error) {
            }
          }}
        />
      </div>

      <div>
        <div>{QRMessage}</div>
        <MainButton
          text="Close"
          onClickAction={handleClose}
          color={COLORS.black}
          textColor={COLORS.white}
          textHoverColor={COLORS.lightGrey}
          hoverColor={COLORS.black}
          shadowColor={"transparent"}
          width={"fit-content"}
        />
      </div>
    </div>
  );
};
